<template>
  <div class="agreement-page">
    <!-- 头部导航 -->
    <div class="ceiling">
      <home-top></home-top>
      <navicat :current="-1" background="#fff"></navicat>
    </div>

    <!-- 头部占位 -->
    <!-- <div class="h-top"></div> -->

    <!-- 协议内容区域 -->
    <div class="agreement-container">
      <div class="w-1400">
        <!-- 面包屑导航 -->
        <div class="bread-crumb">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>{{
                agreeDetail.title || "平台协议"
              }}
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <!-- 协议卡片 -->
        <div class="agreement-card">
          <!-- 协议内容 -->
          <div class="agreement-content" v-loading="loading">
            <div class="content-wrapper" v-if="agreeDetail.content">
              <div class="content-header">
                <div class="content-title">
                  <i class="el-icon-reading"></i>
                  {{ agreeDetail.title || "平台协议" }}
                </div>
                <div class="content-tools">
                  <el-button
                      size="mini"
                      icon="el-icon-zoom-in"
                      @click="increaseFontSize"
                  >
                    放大字体
                  </el-button>
                  <el-button
                      size="mini"
                      icon="el-icon-zoom-out"
                      @click="decreaseFontSize"
                  >
                    缩小字体
                  </el-button>
                  <el-button
                      size="mini"
                      icon="el-icon-refresh"
                      @click="resetFontSize"
                  >
                    默认字体
                  </el-button>
                </div>
              </div>

              <div
                  class="content-body"
                  :style="{ fontSize: fontSize + 'px' }"
                  v-html="agreeDetail.content"
              ></div>
            </div>

            <!-- 空状态 -->
            <div class="empty-state" v-else-if="!loading">
              <div class="empty-icon">
                <i class="el-icon-document"></i>
              </div>
              <div class="empty-text">暂无协议内容</div>
              <el-button type="primary" @click="goBack">返回上一页</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 页脚 -->
    <home-footer></home-footer>
  </div>
</template>

<script>
import {getAgreeList} from "@/api/modules/common";
import homeTop from "../../../components/public/home-top.vue";
import navicat from "../../../components/navicat/navicat.vue";
import homeFooter from "../../../components/public/home-footer.vue";

export default {
  name: "Agreement",
  components: {
    homeTop,
    navicat,
    homeFooter,
  },
  data() {
    return {
      id: this.$route.query.id,
      loading: false,
      fontSize: 16,
      agreeDetail: {
        content: "",
        title: "",
        updated_at: "",
        version: "",
        publisher: "",
        view_count: 0,
      },
      relatedAgreements: [
        {
          id: 2,
          title: "隐私协议",
          description: "了解我们如何保护您的个人信息",
        },
        {
          id: 11,
          title: "服务条款",
          description: "平台服务使用条款和条件",
        },
        {
          id: 10,
          title: "法律声明",
          description: "平台法律声明和免责条款",
        },
      ],
    };
  },
  mounted() {
    this.getAgreement();
  },
  watch: {
    "$route.query.id": {
      handler(newVal) {
        this.id = newVal;
        this.getAgreement();
      },
    },
  },
  methods: {
    async getAgreement() {
      this.loading = true;
      try {
        let res = await getAgreeList({id: this.id});
        if (res.data && res.data.data) {
          this.agreeDetail = res.data.data;
        }
      } catch (error) {
        this.$message.error("获取协议内容失败，请稍后重试");
      } finally {
        this.loading = false;
      }
    },

    formatDate(dateString) {
      if (!dateString) return "未知";
      const date = new Date(dateString);
      return date.toLocaleDateString("zh-CN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    goHome() {
      this.$router.push("/");
    },

    goBack() {
      this.$router.go(-1);
    },

    downloadAgreement() {
      this.$message.info("下载功能开发中...");
    },

    increaseFontSize() {
      if (this.fontSize < 24) {
        this.fontSize += 2;
      }
    },

    decreaseFontSize() {
      if (this.fontSize > 12) {
        this.fontSize -= 2;
      }
    },

    resetFontSize() {
      this.fontSize = 16;
    },

    agreeProtocol() {
      this.$message.success("感谢您同意本协议！");
    },

    goToAgreement(id) {
      this.$router.push(`/agreement/agreement?id=${id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.agreement-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.h-top {
  height: 120px;
}

.agreement-container {
  padding: 20px 0;
}

.bread-crumb {
  padding: 20px 0;
}

.agreement-card {
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-bottom: 40px;
}

.agreement-header {
  display: flex;
  align-items: center;
  padding: 30px 40px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;

  .agreement-icon {
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;

    i {
      font-size: 28px;
    }
  }

  .agreement-title {
    flex: 1;

    h1 {
      margin: 0 0 10px 0;
      font-size: 28px;
      font-weight: 600;
    }

    .agreement-meta {
      display: flex;
      gap: 20px;
      font-size: 14px;
      opacity: 0.9;

      span {
        display: flex;
        align-items: center;
        gap: 5px;
      }
    }
  }

  .agreement-actions {
    display: flex;
    gap: 10px;
  }
}

.agreement-content {
  padding: 40px;
  min-height: 400px;

  .content-wrapper {
    .content-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 30px;
      padding-bottom: 20px;
      border-bottom: 2px solid #f0f0f0;

      .content-title {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 20px;
        font-weight: 600;
        color: #333;

        i {
          color: #409eff;
        }
      }

      .content-tools {
        display: flex;
        gap: 10px;
      }
    }

    .content-body {
      line-height: 1.8;
      color: #333;

      ::v-deep h1,
      ::v-deep h2,
      ::v-deep h3,
      ::v-deep h4,
      ::v-deep h5,
      ::v-deep h6 {
        color: #2c3e50;
        margin: 20px 0 10px 0;
        font-weight: 600;
      }

      ::v-deep p {
        margin: 15px 0;
        text-align: justify;
      }

      ::v-deep ul,
      ::v-deep ol {
        margin: 15px 0;
        padding-left: 20px;
      }

      ::v-deep li {
        margin: 8px 0;
      }

      ::v-deep strong {
        color: #409eff;
        font-weight: 600;
      }

      ::v-deep blockquote {
        background: #f8f9fa;
        border-left: 4px solid #409eff;
        padding: 15px 20px;
        margin: 20px 0;
        border-radius: 0 8px 8px 0;
      }
    }
  }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  text-align: center;

  .empty-icon {
    font-size: 80px;
    color: #ddd;
    margin-bottom: 20px;
  }

  .empty-text {
    font-size: 18px;
    color: #999;
    margin-bottom: 30px;
  }
}

.agreement-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 40px;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;

  .footer-info {
    display: flex;
    gap: 30px;

    .info-item {
      display: flex;
      align-items: center;
      gap: 8px;
      color: #666;
      font-size: 14px;

      i {
        color: #409eff;
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .agreement-header {
    flex-direction: column;
    text-align: center;
    gap: 20px;

    .agreement-actions {
      width: 100%;
      justify-content: center;
    }
  }

  .agreement-footer {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }

  .related-list {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .agreement-content {
    padding: 20px;
  }

  .agreement-header {
    padding: 20px;
  }

  .agreement-footer {
    padding: 20px;
  }
}
</style>
